<template>
  <div id="page-cari-report">
    <!-- Filtre Kartı -->
    <vx-card title="Filtreleme" class="mb-base sale-box-shadow">
      <div class="vx-row">
        <!-- Başlangıç Tarihi -->
        <div class="vx-col w-full sm:w-1/4 mb-4">
          <label class="vs-input--label text-xs">Başlangıç Tarihi</label>
          <vs-input type="date" class="w-full mt-1" v-model="filters.startDate" @change="fetchReport" />
        </div>
        <!-- Bitiş Tarihi -->
        <div class="vx-col w-full sm:w-1/4 mb-4">
          <label class="vs-input--label text-xs">Bitiş Tarihi</label>
          <vs-input type="date" class="w-full mt-1" v-model="filters.endDate" @change="fetchReport" />
        </div>
        <!-- Cari Arama -->
        <div class="vx-col w-full sm:w-1/3 mb-4">
          <label class="vs-input--label text-xs">Cari Hesap Arama</label>
          <vs-select
            class="w-full mt-1"
            v-model="filters.cariId"
            autocomplete
            placeholder="Cari seçin..."
            @change="fetchReport"
          >
            <vs-select-item :value="null" text="Tüm Cariler" />
            <vs-select-item
              v-for="(c, idx) in cariList"
              :key="idx"
              :value="c.id"
              :text="c.name"
            />
          </vs-select>
        </div>
        <!-- Temizle Butonu -->
        <div class="vx-col w-full sm:w-1/6 mb-4 flex items-end">
          <vs-button @click="clearFilters" color="primary" class="w-full">Sıfırla</vs-button>
        </div>
      </div>
    </vx-card>

    <!-- Rapor Listesi Kartı -->
    <vx-card title="Cari Hesap Bakiye Raporu" class="sale-box-shadow">
      <vs-table :data="reportData" noDataText="Kayıt bulunamadı">
        <template slot="thead">
          <vs-th>Cari Adı</vs-th>
          <vs-th>Telefon</vs-th>
          <vs-th>E-posta</vs-th>
          <vs-th>Toplam Borç (Sipariş)</vs-th>
          <vs-th>Toplam Ödenen</vs-th>
          <vs-th>Kalan Bakiye</vs-th>
          <vs-th>İşlem</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-for="(tr, idx) in data" :key="idx" :state="tr.RemainingBalance > 0 ? 'warning' : null">
            <vs-td class="font-bold">{{ tr.cariName }}</vs-td>
            <vs-td>{{ tr.phone || '-' }}</vs-td>
            <vs-td>{{ tr.email || '-' }}</vs-td>
            <vs-td class="text-danger font-semibold">{{ formatPrice(tr.totalDebt) }} TL</vs-td>
            <vs-td class="text-success font-semibold">{{ formatPrice(tr.totalPaid) }} TL</vs-td>
            <vs-td :class="tr.remainingBalance > 0 ? 'text-danger font-bold' : 'text-success font-bold'">
              {{ formatPrice(tr.remainingBalance) }} TL
            </vs-td>
            <vs-td>
              <vs-button
                icon-pack="feather"
                icon="icon-eye"
                size="small"
                @click="openDetails(tr)"
                color="primary"
                type="filled"
                title="Detayları Göster"
              >Detaylar</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <!-- Detay Modal -->
    <vs-popup
      :active.sync="detailsActive"
      v-if="selectedCari"
      style="z-index: 52000;"
      class="cari-details-popup"
      :title="selectedCari.cariName + ' Detayları'"
    >
      <div class="p-6">
        <!-- Rapor Yazdır Butonu -->
        <div class="flex justify-between items-center mb-6">
          <div class="text-lg font-bold" :class="selectedCari.remainingBalance > 0 ? 'text-danger' : 'text-success'">
            Kalan Bakiye: {{ formatPrice(selectedCari.remainingBalance) }} TL
          </div>
          <vs-button icon-pack="feather" icon="icon-printer" color="success" @click="printCariDetails">Adisyon Yazdır</vs-button>
        </div>

        <div class="vx-row">
          <!-- Sipariş Geçmişi (Borçlar) -->
          <div class="vx-col w-full md:w-1/2 mb-6">
            <h5 class="mb-4 font-bold border-b pb-2"><vs-icon icon="receipt" class="mr-2" />Sipariş Geçmişi</h5>
            <div class="max-h-96 overflow-y-auto pr-2">
              <div v-if="orderTransactions.length === 0" class="text-secondary text-sm">Hiç sipariş bulunmamaktadır.</div>
              <vx-card
                v-for="order in orderTransactions"
                :key="order.id"
                class="mb-3 border-l-4 border-danger sale-box-shadow"
                :title="'Sipariş #' + order.id"
                title-color="danger"
              >
                <div slot="no-body" class="p-4">
                  <div class="flex justify-between text-xs text-secondary mb-2">
                    <span>{{ formatDate(order.date) }}</span>
                    <span class="font-bold text-danger">{{ formatPrice(order.amount) }} TL</span>
                  </div>
                  <div class="bg-light p-2 rounded text-xs mt-2">
                    <div v-for="(item, i) in order.items" :key="i" class="flex justify-between py-1">
                      <span>{{ item.productName }} x {{ item.quantity }}</span>
                      <span>{{ formatPrice(item.price) }} TL</span>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>

          <!-- Ödeme Geçmişi (Alacaklar) -->
          <div class="vx-col w-full md:w-1/2 mb-6">
            <h5 class="mb-4 font-bold border-b pb-2"><vs-icon icon="payment" class="mr-2" />Ödeme Geçmişi</h5>
            <div class="max-h-96 overflow-y-auto pr-2">
              <div v-if="paymentTransactions.length === 0" class="text-secondary text-sm">Hiç ödeme bulunmamaktadır.</div>
              <vx-card
                v-for="payment in paymentTransactions"
                :key="payment.id"
                class="mb-3 border-l-4 border-success sale-box-shadow"
                :title="payment.paymentMethodName"
                title-color="success"
              >
                <div slot="no-body" class="p-4">
                  <div class="flex justify-between text-xs text-secondary mb-2">
                    <span>{{ formatDate(payment.date) }}</span>
                    <span class="font-bold text-success">{{ formatPrice(payment.amount) }} TL</span>
                  </div>
                  <p class="text-xs text-secondary mt-1" v-if="payment.description">
                    <strong>Açıklama:</strong> {{ payment.description }}
                  </p>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

    <!-- Yazdırılacak Adisyon Şablonu (Görünmez) -->
    <div id="cariPrintDiv" class="pr-container" style="display:none;">
      <div class="pr-header">
        <h2 class="pr-branch">{{ companyName }}</h2>
        <div class="pr-meta">CARİ HESAP EKSTRESİ</div>
        <div class="pr-meta-user">Tarih: {{ currentPrintDate() }}</div>
      </div>

      <hr class="pr-sep pr-sep-thick" />

      <div class="pr-meta">
        <strong>Müşteri:</strong> {{ selectedCari ? selectedCari.cariName : '' }}<br />
        <strong>Telefon:</strong> {{ selectedCari ? selectedCari.phone || '-' : '-' }}<br />
        <strong>E-posta:</strong> {{ selectedCari ? selectedCari.email || '-' : '-' }}
      </div>

      <hr class="pr-sep" />

      <!-- Hareketler Başlık -->
      <table class="pr-tbl">
        <thead>
          <tr>
            <th class="pr-c-name" style="text-align: left;">Tarih / İşlem</th>
            <th class="pr-c-qty" style="text-align: center;">Tür</th>
            <th class="pr-c-price" style="text-align: right;">Tutar</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="t in allTransactionsSorted">
            <tr :key="t.type + t.id">
              <td style="text-align: left; font-size: 8pt; padding-top: 4pt;">
                {{ formatDateShort(t.date) }}<br/>
                <span style="font-size: 7.5pt; color: #555;">
                  {{ t.type === 'Sipariş' ? 'Sipariş #' + t.id : t.paymentMethodName }}
                </span>
              </td>
              <td style="text-align: center; font-size: 8pt; vertical-align: middle;">
                {{ t.type === 'Sipariş' ? 'Borç' : 'Ödeme' }}
              </td>
              <td style="text-align: right; font-size: 8pt; font-weight: bold; vertical-align: middle;">
                {{ t.type === 'Sipariş' ? '+' : '-' }}{{ formatPrice(t.amount) }}
              </td>
            </tr>
            <tr v-if="t.type === 'Sipariş'" :key="t.type + t.id + '-items'">
              <td colspan="3" style="padding-left: 10px; font-size: 7.5pt; color: #444; border-bottom: 1px dotted #ccc;">
                <div v-for="(item, i) in t.items" :key="i">
                  * {{ item.productName }} x{{ item.quantity }} ({{ formatPrice(item.price) }} TL)
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <hr class="pr-sep pr-sep-thick" />

      <div style="font-size: 10pt; font-weight: bold; text-align: right; margin-top: 5px;">
        Toplam Borç: {{ selectedCari ? formatPrice(selectedCari.totalDebt) : '0.00' }} TL<br/>
        Toplam Ödenen: {{ selectedCari ? formatPrice(selectedCari.totalPaid) : '0.00' }} TL<br/>
        <div style="font-size: 11pt; border-top: 1px solid #000; display: inline-block; padding-top: 2px; margin-top: 3px;">
          Kalan Bakiye: {{ selectedCari ? formatPrice(selectedCari.remainingBalance) : '0.00' }} TL
        </div>
      </div>

      <hr class="pr-sep" />
      <div style="text-align: center; font-size: 8pt; margin-top: 10px; font-style: italic;">
        Bilgi amaçlı dökülmüştür. Mali değeri yoktur.
      </div>
    </div>
  </div>
</template>

<script>
import { getAllCari, getCariReport, getCariTransactions } from "@/api/Cari";
import companyInfo from "@/model/constants/companyInfo";
import printJS from "print-js";

const PRINT_CSS = `
  @page { size: 80mm auto; margin: 0; }
  @media print {
    body { margin: 0; padding: 0; background: #fff; color: #000; }
    .pr-container { width: 80mm; padding: 10pt 6pt; box-sizing: border-box; background: #fff; page-break-after: always; break-after: page; }
  }
  body { font-family: 'Courier New', Courier, monospace; }
  .pr-container { width: 80mm; padding: 10pt 6pt; box-sizing: border-box; color: #000; background: #fff; }
  .pr-header { text-align: center; margin-bottom: 8pt; }
  .pr-branch { font-size: 12pt; font-weight: 900; margin-bottom: 4pt; text-transform: uppercase; }
  .pr-meta { font-size: 9pt; line-height: 1.4; }
  .pr-meta-user { font-size: 8pt; margin-top: 2pt; }
  .pr-sep { border: 0; border-top: 1.5px dashed #000; margin: 4pt 0; display: block; }
  .pr-sep-thick { border-top: 2px solid #000 !important; margin: 4pt 0; }
  .pr-tbl { width: 100%; border-collapse: collapse; margin-bottom: 4pt; }
  .pr-c-name { width: 50%; }
  .pr-c-qty { width: 20%; }
  .pr-c-price { width: 30%; }
`;

export default {
  data() {
    return {
      companyName: companyInfo.companyName,
      cariList: [],
      reportData: [],
      filters: {
        startDate: '',
        endDate: '',
        cariId: null
      },
      detailsActive: false,
      selectedCari: null,
      transactions: [],
      orderTransactions: [],
      paymentTransactions: []
    };
  },

  computed: {
    allTransactionsSorted() {
      return [...this.transactions].sort((a, b) => new Date(a.date) - new Date(b.date));
    }
  },

  watch: {
    detailsActive(val) {
      if (!val) {
        this.selectedCari = null;
        this.transactions = [];
        this.orderTransactions = [];
        this.paymentTransactions = [];
      }
    }
  },

  mounted() {
    this.fetchCariList();
    this.fetchReport();
  },

  methods: {
    async fetchCariList() {
      try {
        const res = await getAllCari();
        this.cariList = res.data || [];
      } catch (err) {
        console.error(err);
      }
    },

    async fetchReport() {
      try {
        const res = await getCariReport({
          startDate: this.filters.startDate || null,
          endDate: this.filters.endDate || null,
          cariId: this.filters.cariId
        });
        this.reportData = res.data || [];
      } catch (err) {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata',
          text: 'Cari raporu yüklenemedi.'
        });
      }
    },

    clearFilters() {
      this.filters.startDate = '';
      this.filters.endDate = '';
      this.filters.cariId = null;
      this.fetchReport();
    },

    async openDetails(cari) {
      this.selectedCari = cari;
      this.detailsActive = true;
      try {
        const res = await getCariTransactions(cari.cariId);
        this.transactions = res.data || [];
        this.orderTransactions = this.transactions.filter(t => t.type === 'Sipariş');
        this.paymentTransactions = this.transactions.filter(t => t.type === 'Ödeme');
      } catch (err) {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata',
          text: 'Cari hesap hareketleri yüklenemedi.'
        });
      }
    },

    formatPrice(val) {
      if (val === undefined || val === null) return '0,00';
      return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val);
    },

    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleString('tr-TR');
    },

    formatDateShort(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('tr-TR') + ' ' + d.toTimeString().substring(0, 5);
    },

    currentPrintDate() {
      return new Date().toLocaleString('tr-TR');
    },

    printCariDetails() {
      // Show the print section dynamically for rendering
      const printDiv = document.getElementById('cariPrintDiv');
      if (printDiv) {
        printDiv.style.display = 'block';
        this.$nextTick(() => {
          setTimeout(() => {
            printJS({
              showModal: false,
              printable: 'cariPrintDiv',
              type: 'html',
              style: PRINT_CSS,
              scanStyles: false
            });
            printDiv.style.display = 'none';
          }, 150);
        });
      }
    }
  }
};
</script>

<style scoped>
.bg-light {
  background-color: rgba(0, 0, 0, 0.03);
}
.cari-details-popup ::v-deep .vs-popup {
  width: 900px !important;
  max-width: 95% !important;
}
</style>
